import * as Types from '../../../../graphql/generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type ContactCollectionEventFragment = {
  __typename?: 'Event';
  id: string;
  pages: Array<{
    __typename?: 'EventPage';
    id: string;
    type: Types.EventPageType;
    pageSlug: string;
    pageTitle: string;
    disabled: boolean;
    visibility: Types.EventPageVisibility;
    isPageContainer: boolean;
    subTitle?: string | null;
    photoV2?:
      | {
          __typename?: 'DefaultPagePhoto';
          id: string;
          url: string;
          width: number;
          height: number;
          altTag?: string | null;
          layout: { __typename?: 'DefaultPagePhotoLayout'; alignX: string; alignY: string };
        }
      | {
          __typename?: 'Photo';
          id: string;
          url: string;
          width: number;
          height: number;
          altTag?: string | null;
          layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string };
          transform?: { __typename?: 'PhotoTransform'; x?: number | null; y?: number | null } | null;
        }
      | null;
    mobilePhoto?: {
      __typename?: 'Photo';
      id: string;
      url: string;
      width: number;
      height: number;
      altTag?: string | null;
      layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string };
      transform?: { __typename?: 'PhotoTransform'; x?: number | null; y?: number | null } | null;
    } | null;
    photoPresentation?: {
      __typename?: 'WebsitePagePhotoPresentation';
      id: string;
      presentationLayout: string;
      cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo'; x: number; y: number; width: number; height: number; unit: string } | null;
    } | null;
  }>;
  info: { __typename?: 'EventInfo'; id: string; ownerFirstName?: string | null; fianceeFirstName?: string | null; dateV0918?: { __typename?: 'Date'; dateString: string } | null };
};

export type GetContactCollectionByEventIdAndNamesByEventHandleQueryVariables = Types.Exact<{
  eventId: Types.Scalars['String'];
  eventHandle: Types.Scalars['String'];
}>;

export type GetContactCollectionByEventIdAndNamesByEventHandleQuery = {
  __typename?: 'Query';
  getContactCollectionByEventId?: {
    __typename?: 'ContactCollection';
    id: string;
    eventDateDisplayEnabled: boolean;
    websiteLinkEnabled: boolean;
    mediaSource: string;
    mediaType: string;
    message: string;
    magicLink: string;
    active?: boolean | null;
    collectHousehold?: boolean | null;
    contacts?: Array<{ __typename?: 'Contact'; id: string; firstName: string; lastName: string; createdAt: any } | null> | null;
  } | null;
  eventByName?: {
    __typename?: 'Event';
    id: string;
    pages: Array<{
      __typename?: 'EventPage';
      id: string;
      type: Types.EventPageType;
      pageSlug: string;
      pageTitle: string;
      disabled: boolean;
      visibility: Types.EventPageVisibility;
      isPageContainer: boolean;
      subTitle?: string | null;
      photoV2?:
        | {
            __typename?: 'DefaultPagePhoto';
            id: string;
            url: string;
            width: number;
            height: number;
            altTag?: string | null;
            layout: { __typename?: 'DefaultPagePhotoLayout'; alignX: string; alignY: string };
          }
        | {
            __typename?: 'Photo';
            id: string;
            url: string;
            width: number;
            height: number;
            altTag?: string | null;
            layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string };
            transform?: { __typename?: 'PhotoTransform'; x?: number | null; y?: number | null } | null;
          }
        | null;
      mobilePhoto?: {
        __typename?: 'Photo';
        id: string;
        url: string;
        width: number;
        height: number;
        altTag?: string | null;
        layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string };
        transform?: { __typename?: 'PhotoTransform'; x?: number | null; y?: number | null } | null;
      } | null;
      photoPresentation?: {
        __typename?: 'WebsitePagePhotoPresentation';
        id: string;
        presentationLayout: string;
        cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo'; x: number; y: number; width: number; height: number; unit: string } | null;
      } | null;
    }>;
    info: {
      __typename?: 'EventInfo';
      id: string;
      ownerFirstName?: string | null;
      fianceeFirstName?: string | null;
      dateV0918?: { __typename?: 'Date'; dateString: string } | null;
    };
  } | null;
};

export type GetContactCollectionByMagicLinkQueryVariables = Types.Exact<{
  magicLink: Types.Scalars['String'];
}>;

export type GetContactCollectionByMagicLinkQuery = {
  __typename?: 'Query';
  getContactCollectionByMagicLink?: {
    __typename?: 'ContactCollection';
    id: string;
    eventId?: string | null;
    eventDateDisplayEnabled: boolean;
    mediaSource: string;
    mediaType: string;
    message: string;
    websiteLinkEnabled: boolean;
    active?: boolean | null;
    collectHousehold?: boolean | null;
  } | null;
};

export type GetDataForContactCollectionGuestQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetDataForContactCollectionGuestQuery = {
  __typename?: 'Query';
  eventById?: {
    __typename?: 'Event';
    id: string;
    firebaseId: string;
    website: string;
    info: {
      __typename?: 'EventInfo';
      id: string;
      eventDisplayName?: string | null;
      ownerFirstName?: string | null;
      fianceeFirstName?: string | null;
      dateV0918?: { __typename?: 'Date'; dateString: string } | null;
    };
    eventDesign?: {
      __typename?: 'EventDesign';
      id: string;
      hasUnpublishedChanges: boolean;
      hasVisitedDesignPage?: boolean | null;
      guestSiteTarget: Types.GuestSiteTargetEnum;
      brannanNavigation: Types.BrannanNavigation;
      useCustomTheme: boolean;
      accent?: string | null;
      customCss: string;
      linkAndButtonColor?: string | null;
      artFontColor?: string | null;
      artBackgroundColor?: string | null;
      pageBackgroundColor?: string | null;
      pageFontColor?: string | null;
      websiteLayout: { __typename?: 'DesignLayout'; id: string; layoutType: Types.DesignLayoutType; name: string };
      font: { __typename?: 'Font'; id: string; display: string; fontFamily: string; textTransform: Types.FontWeight };
      fonts?: Array<{
        __typename?: 'FontPackConfiguration';
        id: string;
        category: Types.Category;
        size?: number | null;
        sizePercent?: number | null;
        font?: { __typename?: 'Font'; id: string; fontFamily: string; fontSize: number; fontWeight: number; firebaseFontKey: string } | null;
      }> | null;
      theme: {
        __typename?: 'Theme';
        id: string;
        themeId: string;
        name: string;
        colorSchemes: Array<{ __typename?: 'ThemeColorScheme'; id: string; colors: Array<{ __typename?: 'Color'; hex: string; isLight: boolean }> }>;
        designLayouts: Array<{ __typename?: 'DesignLayout'; id: string }>;
        websiteLayoutBrannanSettings?: {
          __typename?: 'WebsiteLayoutBrannanSettings';
          brannanBackgroundTransparency?: {
            __typename?: 'DesignPreferenceRange';
            supportsCustomization: boolean;
            id: string;
            featureName: string;
            featureValueType: Types.FeatureValueType;
            rangeValue: number;
            rangeMax: number;
            rangeMin: number;
            rangeStep: number;
          } | null;
        } | null;
        websiteLayoutAlohaSettings?: {
          __typename?: 'WebsiteLayoutAlohaSettings';
          alohaColorPreference?: {
            __typename?: 'DesignPreferenceColor';
            id: string;
            featureName: string;
            featureValueType: Types.FeatureValueType;
            supportsCustomization: boolean;
            colorValue: { __typename?: 'Color'; hex: string; isLight: boolean };
          } | null;
          alohaTextColorPreference?: {
            __typename?: 'DesignPreferenceColor';
            id: string;
            featureName: string;
            featureValueType: Types.FeatureValueType;
            supportsCustomization: boolean;
            colorValue: { __typename?: 'Color'; hex: string; isLight: boolean };
          } | null;
        } | null;
      };
      colorPalette: Array<{ __typename?: 'ColorSet'; id: string; color: { __typename?: 'Color'; hex: string; isLight: boolean } }>;
      activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings'; dataJSON: any; schemaURL: string; websiteLayout: string; id: string } | null;
      customTheme?: {
        __typename?: 'CustomTheme';
        id: string;
        desktopThemeAsset?: { __typename?: 'CustomThemeAsset'; id: string; assetURL: string } | null;
        mobileThemeAsset?: { __typename?: 'CustomThemeAsset'; id: string; assetURL: string } | null;
      } | null;
      designPreferences: Array<
        | {
            __typename?: 'EventDesignPreferenceBoolean';
            id: string;
            featureId: string;
            featureName: string;
            featureType: Types.DesignFeatureType;
            featureValueType: Types.FeatureValueType;
            booleanValue: boolean;
          }
        | {
            __typename?: 'EventDesignPreferenceColorPointer';
            id: string;
            featureName: string;
            featureType: Types.DesignFeatureType;
            colorPointer?: number | null;
            colorPointerPosition?: Types.ColorPointerLocation | null;
          }
        | {
            __typename?: 'EventDesignPreferenceRange';
            id: string;
            featureId: string;
            featureName: string;
            featureType: Types.DesignFeatureType;
            featureValueType: Types.FeatureValueType;
            rangeValue: number;
          }
      >;
    } | null;
  } | null;
};

export type GetTelemetryDataForContactCollectionGuestQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetTelemetryDataForContactCollectionGuestQuery = {
  __typename?: 'Query';
  eventById?: { __typename?: 'Event'; id: string; firebaseId: string; website: string; info: { __typename?: 'EventInfo'; id: string; eventType: Types.EventType } } | null;
};

export type GetContactsByContactCollectionQueryVariables = Types.Exact<{
  contactCollectionId: Types.Scalars['ID'];
}>;

export type GetContactsByContactCollectionQuery = { __typename?: 'Query'; getContactsByContactCollection?: Array<{ __typename?: 'Contact'; id: string } | null> | null };

export type AuthenticateUserQueryVariables = Types.Exact<{
  authToken: Types.Scalars['String'];
}>;

export type AuthenticateUserQuery = { __typename?: 'Query'; authenticateUser?: { __typename?: 'AuthenticatedUserResult'; userJWT: string } | null };

export type GetContactCollectionByFirebaseEventIdOrCreateOneQueryVariables = Types.Exact<{
  firebaseEventId: Types.Scalars['ID'];
}>;

export type GetContactCollectionByFirebaseEventIdOrCreateOneQuery = {
  __typename?: 'Query';
  getContactCollectionByFirebaseEventIdOrCreateOne?: { __typename?: 'ContactCollection'; id: string; eventId?: string | null } | null;
};

export type CreateContactCollectionMutationVariables = Types.Exact<{
  data: Types.ContactCollectionInput;
}>;

export type CreateContactCollectionMutation = { __typename?: 'Mutation'; createContactCollection: { __typename?: 'ContactCollection'; id: string; magicLink: string } };

export type UpdateContactCollectionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  data: Types.ContactCollectionInput;
}>;

export type UpdateContactCollectionMutation = { __typename?: 'Mutation'; updateContactCollection: { __typename?: 'ContactCollection'; id: string; magicLink: string } };

export type CreateContactMutationVariables = Types.Exact<{
  data: Types.ContactInput;
}>;

export type CreateContactMutation = { __typename?: 'Mutation'; createContact: { __typename?: 'Contact'; id: string; householdId: string } };

export type CreateContactsWithoutTagsMutationVariables = Types.Exact<{
  data: Array<Types.ContactInputWithoutTags> | Types.ContactInputWithoutTags;
}>;

export type CreateContactsWithoutTagsMutation = { __typename?: 'Mutation'; createContactsWithoutTags: Array<{ __typename?: 'Contact'; id: string }> };

export type UpdateContactMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  data: Types.ContactInput;
}>;

export type UpdateContactMutation = { __typename?: 'Mutation'; updateContact: { __typename?: 'Contact'; id: string; householdId: string } };

export type DeleteContactsByContactIdsMutationVariables = Types.Exact<{
  contactIds: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;

export type DeleteContactsByContactIdsMutation = { __typename?: 'Mutation'; deleteContactsByContactIds: Array<{ __typename?: 'Contact'; id: string }> };

export const ContactCollectionEventFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContactCollectionEvent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pages' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventPage' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'info' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateV0918' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateString' },
                        arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'long' } }],
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventPage' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventPage' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSlug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageTitle' } },
          { kind: 'Field', alias: { kind: 'Name', value: 'subTitle' }, name: { kind: 'Name', value: 'pageSubTitleV0918' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPageContainer' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoV2' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoV2WithoutBlurHash' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobilePhoto' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoWithoutBlurHash' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoPresentation' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsitePagePhotoPresentation' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoV2WithoutBlurHash' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PagePhoto' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'layout' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoLayout' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transform' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoTransform' } }] },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DefaultPagePhoto' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'layout' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoLayoutV2' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoLayout' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoTransform' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoTransform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoLayoutV2' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DefaultPagePhotoLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoWithoutBlurHash' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoLayout' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transform' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoTransform' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsitePagePhotoPresentation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsitePagePhotoPresentation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'presentationLayout' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cropInfo' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsitePagePhotoPresentationCropInfo' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsitePagePhotoPresentationCropInfo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsitePagePhotoPresentationCropInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetContactCollectionByEventIdAndNamesByEventHandleDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetContactCollectionByEventIdAndNamesByEventHandle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getContactCollectionByEventId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDateDisplayEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteLinkEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mediaSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'magicLink' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'collectHousehold' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContactCollectionEvent' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContactCollectionEvent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pages' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventPage' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'info' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateV0918' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateString' },
                        arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'long' } }],
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventPage' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventPage' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSlug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageTitle' } },
          { kind: 'Field', alias: { kind: 'Name', value: 'subTitle' }, name: { kind: 'Name', value: 'pageSubTitleV0918' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPageContainer' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoV2' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoV2WithoutBlurHash' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobilePhoto' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoWithoutBlurHash' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoPresentation' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsitePagePhotoPresentation' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoV2WithoutBlurHash' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PagePhoto' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'layout' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoLayout' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transform' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoTransform' } }] },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DefaultPagePhoto' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'layout' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoLayoutV2' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoLayout' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoTransform' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoTransform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoLayoutV2' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DefaultPagePhotoLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoWithoutBlurHash' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoLayout' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transform' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoTransform' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsitePagePhotoPresentation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsitePagePhotoPresentation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'presentationLayout' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cropInfo' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsitePagePhotoPresentationCropInfo' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsitePagePhotoPresentationCropInfo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsitePagePhotoPresentationCropInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetContactCollectionByEventIdAndNamesByEventHandleQuery__
 *
 * To run a query within a React component, call `useGetContactCollectionByEventIdAndNamesByEventHandleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactCollectionByEventIdAndNamesByEventHandleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactCollectionByEventIdAndNamesByEventHandleQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetContactCollectionByEventIdAndNamesByEventHandleQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactCollectionByEventIdAndNamesByEventHandleQuery, GetContactCollectionByEventIdAndNamesByEventHandleQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetContactCollectionByEventIdAndNamesByEventHandleQuery, GetContactCollectionByEventIdAndNamesByEventHandleQueryVariables>(
    GetContactCollectionByEventIdAndNamesByEventHandleDocument,
    baseOptions,
  );
}
export function useGetContactCollectionByEventIdAndNamesByEventHandleLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactCollectionByEventIdAndNamesByEventHandleQuery, GetContactCollectionByEventIdAndNamesByEventHandleQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetContactCollectionByEventIdAndNamesByEventHandleQuery, GetContactCollectionByEventIdAndNamesByEventHandleQueryVariables>(
    GetContactCollectionByEventIdAndNamesByEventHandleDocument,
    baseOptions,
  );
}
export type GetContactCollectionByEventIdAndNamesByEventHandleQueryHookResult = ReturnType<typeof useGetContactCollectionByEventIdAndNamesByEventHandleQuery>;
export type GetContactCollectionByEventIdAndNamesByEventHandleLazyQueryHookResult = ReturnType<typeof useGetContactCollectionByEventIdAndNamesByEventHandleLazyQuery>;
export type GetContactCollectionByEventIdAndNamesByEventHandleQueryResult = Apollo.QueryResult<
  GetContactCollectionByEventIdAndNamesByEventHandleQuery,
  GetContactCollectionByEventIdAndNamesByEventHandleQueryVariables
>;
export const GetContactCollectionByMagicLinkDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetContactCollectionByMagicLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'magicLink' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getContactCollectionByMagicLink' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'magicLink' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'magicLink' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDateDisplayEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mediaSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteLinkEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'collectHousehold' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetContactCollectionByMagicLinkQuery__
 *
 * To run a query within a React component, call `useGetContactCollectionByMagicLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactCollectionByMagicLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactCollectionByMagicLinkQuery({
 *   variables: {
 *      magicLink: // value for 'magicLink'
 *   },
 * });
 */
export function useGetContactCollectionByMagicLinkQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactCollectionByMagicLinkQuery, GetContactCollectionByMagicLinkQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetContactCollectionByMagicLinkQuery, GetContactCollectionByMagicLinkQueryVariables>(GetContactCollectionByMagicLinkDocument, baseOptions);
}
export function useGetContactCollectionByMagicLinkLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactCollectionByMagicLinkQuery, GetContactCollectionByMagicLinkQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetContactCollectionByMagicLinkQuery, GetContactCollectionByMagicLinkQueryVariables>(GetContactCollectionByMagicLinkDocument, baseOptions);
}
export type GetContactCollectionByMagicLinkQueryHookResult = ReturnType<typeof useGetContactCollectionByMagicLinkQuery>;
export type GetContactCollectionByMagicLinkLazyQueryHookResult = ReturnType<typeof useGetContactCollectionByMagicLinkLazyQuery>;
export type GetContactCollectionByMagicLinkQueryResult = Apollo.QueryResult<GetContactCollectionByMagicLinkQuery, GetContactCollectionByMagicLinkQueryVariables>;
export const GetDataForContactCollectionGuestDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDataForContactCollectionGuest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firebaseId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateV0918' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'dateString' },
                              arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventDesign' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'purpose' }, value: { kind: 'EnumValue', value: 'live' } }],
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventDesign' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventDesign' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesign' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasVisitedDesignPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestSiteTarget' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brannanNavigation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useCustomTheme' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'websiteLayout' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignLayout' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'font' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
                { kind: 'Field', name: { kind: 'Name', value: 'textTransform' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fonts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fontWeight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firebaseFontKey' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizePercent' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'theme' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorSchemes' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ThemeColorScheme' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'designLayouts' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'websiteLayoutBrannanSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'brannanBackgroundTransparency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignPreferenceRange' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'supportsCustomization' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'websiteLayoutAlohaSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'alohaColorPreference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignPreferenceColor' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'alohaTextColorPreference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignPreferenceColor' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'accent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customCss' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colorPalette' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ColorSet' } }] },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsiteEventColors' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeWebsiteHeaderPresentationLayout' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useCustomTheme' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTheme' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTheme' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'designPreferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceColorPointer' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventDesignPreferenceColorPointer' } }] },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceRange' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventDesignPreferenceRange' } }] },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceBoolean' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventDesignPreferenceBoolean' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DesignLayout' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DesignLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ThemeColorScheme' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ThemeColorScheme' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Color' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Color' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Color' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLight' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DesignPreferenceRange' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DesignPreferenceRange' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureValueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsCustomization' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DesignPreferenceColor' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DesignPreferenceColor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureValueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsCustomization' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colorValue' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Color' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ColorSet' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ColorSet' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Color' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsiteEventColors' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesign' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'linkAndButtonColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'artFontColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'artBackgroundColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageBackgroundColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageFontColor' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dataJSON' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteLayout' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTheme' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTheme' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktopThemeAsset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assetURL' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobileThemeAsset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assetURL' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventDesignPreferenceColorPointer' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceColorPointer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'colorPointer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'colorPointerPosition' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventDesignPreferenceRange' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceRange' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureValueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeValue' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventDesignPreferenceBoolean' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceBoolean' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureValueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'booleanValue' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetDataForContactCollectionGuestQuery__
 *
 * To run a query within a React component, call `useGetDataForContactCollectionGuestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataForContactCollectionGuestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataForContactCollectionGuestQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetDataForContactCollectionGuestQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetDataForContactCollectionGuestQuery, GetDataForContactCollectionGuestQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetDataForContactCollectionGuestQuery, GetDataForContactCollectionGuestQueryVariables>(GetDataForContactCollectionGuestDocument, baseOptions);
}
export function useGetDataForContactCollectionGuestLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDataForContactCollectionGuestQuery, GetDataForContactCollectionGuestQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetDataForContactCollectionGuestQuery, GetDataForContactCollectionGuestQueryVariables>(
    GetDataForContactCollectionGuestDocument,
    baseOptions,
  );
}
export type GetDataForContactCollectionGuestQueryHookResult = ReturnType<typeof useGetDataForContactCollectionGuestQuery>;
export type GetDataForContactCollectionGuestLazyQueryHookResult = ReturnType<typeof useGetDataForContactCollectionGuestLazyQuery>;
export type GetDataForContactCollectionGuestQueryResult = Apollo.QueryResult<GetDataForContactCollectionGuestQuery, GetDataForContactCollectionGuestQueryVariables>;
export const GetTelemetryDataForContactCollectionGuestDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTelemetryDataForContactCollectionGuest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firebaseId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'website' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTelemetryDataForContactCollectionGuestQuery__
 *
 * To run a query within a React component, call `useGetTelemetryDataForContactCollectionGuestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTelemetryDataForContactCollectionGuestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTelemetryDataForContactCollectionGuestQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetTelemetryDataForContactCollectionGuestQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetTelemetryDataForContactCollectionGuestQuery, GetTelemetryDataForContactCollectionGuestQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetTelemetryDataForContactCollectionGuestQuery, GetTelemetryDataForContactCollectionGuestQueryVariables>(
    GetTelemetryDataForContactCollectionGuestDocument,
    baseOptions,
  );
}
export function useGetTelemetryDataForContactCollectionGuestLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTelemetryDataForContactCollectionGuestQuery, GetTelemetryDataForContactCollectionGuestQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetTelemetryDataForContactCollectionGuestQuery, GetTelemetryDataForContactCollectionGuestQueryVariables>(
    GetTelemetryDataForContactCollectionGuestDocument,
    baseOptions,
  );
}
export type GetTelemetryDataForContactCollectionGuestQueryHookResult = ReturnType<typeof useGetTelemetryDataForContactCollectionGuestQuery>;
export type GetTelemetryDataForContactCollectionGuestLazyQueryHookResult = ReturnType<typeof useGetTelemetryDataForContactCollectionGuestLazyQuery>;
export type GetTelemetryDataForContactCollectionGuestQueryResult = Apollo.QueryResult<
  GetTelemetryDataForContactCollectionGuestQuery,
  GetTelemetryDataForContactCollectionGuestQueryVariables
>;
export const GetContactsByContactCollectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetContactsByContactCollection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactCollectionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getContactsByContactCollection' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'contactCollectionId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'contactCollectionId' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetContactsByContactCollectionQuery__
 *
 * To run a query within a React component, call `useGetContactsByContactCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsByContactCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsByContactCollectionQuery({
 *   variables: {
 *      contactCollectionId: // value for 'contactCollectionId'
 *   },
 * });
 */
export function useGetContactsByContactCollectionQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactsByContactCollectionQuery, GetContactsByContactCollectionQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetContactsByContactCollectionQuery, GetContactsByContactCollectionQueryVariables>(GetContactsByContactCollectionDocument, baseOptions);
}
export function useGetContactsByContactCollectionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactsByContactCollectionQuery, GetContactsByContactCollectionQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetContactsByContactCollectionQuery, GetContactsByContactCollectionQueryVariables>(GetContactsByContactCollectionDocument, baseOptions);
}
export type GetContactsByContactCollectionQueryHookResult = ReturnType<typeof useGetContactsByContactCollectionQuery>;
export type GetContactsByContactCollectionLazyQueryHookResult = ReturnType<typeof useGetContactsByContactCollectionLazyQuery>;
export type GetContactsByContactCollectionQueryResult = Apollo.QueryResult<GetContactsByContactCollectionQuery, GetContactsByContactCollectionQueryVariables>;
export const AuthenticateUserDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AuthenticateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'authToken' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authenticateUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'authToken' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'authToken' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'userJWT' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAuthenticateUserQuery__
 *
 * To run a query within a React component, call `useAuthenticateUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthenticateUserQuery({
 *   variables: {
 *      authToken: // value for 'authToken'
 *   },
 * });
 */
export function useAuthenticateUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AuthenticateUserQuery, AuthenticateUserQueryVariables>) {
  return ApolloReactHooks.useQuery<AuthenticateUserQuery, AuthenticateUserQueryVariables>(AuthenticateUserDocument, baseOptions);
}
export function useAuthenticateUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AuthenticateUserQuery, AuthenticateUserQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<AuthenticateUserQuery, AuthenticateUserQueryVariables>(AuthenticateUserDocument, baseOptions);
}
export type AuthenticateUserQueryHookResult = ReturnType<typeof useAuthenticateUserQuery>;
export type AuthenticateUserLazyQueryHookResult = ReturnType<typeof useAuthenticateUserLazyQuery>;
export type AuthenticateUserQueryResult = Apollo.QueryResult<AuthenticateUserQuery, AuthenticateUserQueryVariables>;
export const GetContactCollectionByFirebaseEventIdOrCreateOneDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetContactCollectionByFirebaseEventIdOrCreateOne' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firebaseEventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getContactCollectionByFirebaseEventIdOrCreateOne' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'firebaseEventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'firebaseEventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetContactCollectionByFirebaseEventIdOrCreateOneQuery__
 *
 * To run a query within a React component, call `useGetContactCollectionByFirebaseEventIdOrCreateOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactCollectionByFirebaseEventIdOrCreateOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactCollectionByFirebaseEventIdOrCreateOneQuery({
 *   variables: {
 *      firebaseEventId: // value for 'firebaseEventId'
 *   },
 * });
 */
export function useGetContactCollectionByFirebaseEventIdOrCreateOneQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactCollectionByFirebaseEventIdOrCreateOneQuery, GetContactCollectionByFirebaseEventIdOrCreateOneQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetContactCollectionByFirebaseEventIdOrCreateOneQuery, GetContactCollectionByFirebaseEventIdOrCreateOneQueryVariables>(
    GetContactCollectionByFirebaseEventIdOrCreateOneDocument,
    baseOptions,
  );
}
export function useGetContactCollectionByFirebaseEventIdOrCreateOneLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactCollectionByFirebaseEventIdOrCreateOneQuery, GetContactCollectionByFirebaseEventIdOrCreateOneQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetContactCollectionByFirebaseEventIdOrCreateOneQuery, GetContactCollectionByFirebaseEventIdOrCreateOneQueryVariables>(
    GetContactCollectionByFirebaseEventIdOrCreateOneDocument,
    baseOptions,
  );
}
export type GetContactCollectionByFirebaseEventIdOrCreateOneQueryHookResult = ReturnType<typeof useGetContactCollectionByFirebaseEventIdOrCreateOneQuery>;
export type GetContactCollectionByFirebaseEventIdOrCreateOneLazyQueryHookResult = ReturnType<typeof useGetContactCollectionByFirebaseEventIdOrCreateOneLazyQuery>;
export type GetContactCollectionByFirebaseEventIdOrCreateOneQueryResult = Apollo.QueryResult<
  GetContactCollectionByFirebaseEventIdOrCreateOneQuery,
  GetContactCollectionByFirebaseEventIdOrCreateOneQueryVariables
>;
export const CreateContactCollectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateContactCollection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactCollectionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createContactCollection' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'magicLink' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateContactCollectionMutationFn = Apollo.MutationFunction<CreateContactCollectionMutation, CreateContactCollectionMutationVariables>;

/**
 * __useCreateContactCollectionMutation__
 *
 * To run a mutation, you first call `useCreateContactCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactCollectionMutation, { data, loading, error }] = useCreateContactCollectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContactCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateContactCollectionMutation, CreateContactCollectionMutationVariables>) {
  return ApolloReactHooks.useMutation<CreateContactCollectionMutation, CreateContactCollectionMutationVariables>(CreateContactCollectionDocument, baseOptions);
}
export type CreateContactCollectionMutationHookResult = ReturnType<typeof useCreateContactCollectionMutation>;
export type CreateContactCollectionMutationResult = Apollo.MutationResult<CreateContactCollectionMutation>;
export type CreateContactCollectionMutationOptions = Apollo.BaseMutationOptions<CreateContactCollectionMutation, CreateContactCollectionMutationVariables>;
export const UpdateContactCollectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateContactCollection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactCollectionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateContactCollection' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'magicLink' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateContactCollectionMutationFn = Apollo.MutationFunction<UpdateContactCollectionMutation, UpdateContactCollectionMutationVariables>;

/**
 * __useUpdateContactCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateContactCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactCollectionMutation, { data, loading, error }] = useUpdateContactCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContactCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContactCollectionMutation, UpdateContactCollectionMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateContactCollectionMutation, UpdateContactCollectionMutationVariables>(UpdateContactCollectionDocument, baseOptions);
}
export type UpdateContactCollectionMutationHookResult = ReturnType<typeof useUpdateContactCollectionMutation>;
export type UpdateContactCollectionMutationResult = Apollo.MutationResult<UpdateContactCollectionMutation>;
export type UpdateContactCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateContactCollectionMutation, UpdateContactCollectionMutationVariables>;
export const CreateContactDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createContact' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'householdId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
  return ApolloReactHooks.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, baseOptions);
}
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const CreateContactsWithoutTagsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateContactsWithoutTags' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactInputWithoutTags' } } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createContactsWithoutTags' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateContactsWithoutTagsMutationFn = Apollo.MutationFunction<CreateContactsWithoutTagsMutation, CreateContactsWithoutTagsMutationVariables>;

/**
 * __useCreateContactsWithoutTagsMutation__
 *
 * To run a mutation, you first call `useCreateContactsWithoutTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactsWithoutTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactsWithoutTagsMutation, { data, loading, error }] = useCreateContactsWithoutTagsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContactsWithoutTagsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateContactsWithoutTagsMutation, CreateContactsWithoutTagsMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateContactsWithoutTagsMutation, CreateContactsWithoutTagsMutationVariables>(CreateContactsWithoutTagsDocument, baseOptions);
}
export type CreateContactsWithoutTagsMutationHookResult = ReturnType<typeof useCreateContactsWithoutTagsMutation>;
export type CreateContactsWithoutTagsMutationResult = Apollo.MutationResult<CreateContactsWithoutTagsMutation>;
export type CreateContactsWithoutTagsMutationOptions = Apollo.BaseMutationOptions<CreateContactsWithoutTagsMutation, CreateContactsWithoutTagsMutationVariables>;
export const UpdateContactDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateContact' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'householdId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, baseOptions);
}
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const DeleteContactsByContactIdsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteContactsByContactIds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactIds' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteContactsByContactIds' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'contactIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'contactIds' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteContactsByContactIdsMutationFn = Apollo.MutationFunction<DeleteContactsByContactIdsMutation, DeleteContactsByContactIdsMutationVariables>;

/**
 * __useDeleteContactsByContactIdsMutation__
 *
 * To run a mutation, you first call `useDeleteContactsByContactIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactsByContactIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactsByContactIdsMutation, { data, loading, error }] = useDeleteContactsByContactIdsMutation({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useDeleteContactsByContactIdsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteContactsByContactIdsMutation, DeleteContactsByContactIdsMutationVariables>,
) {
  return ApolloReactHooks.useMutation<DeleteContactsByContactIdsMutation, DeleteContactsByContactIdsMutationVariables>(DeleteContactsByContactIdsDocument, baseOptions);
}
export type DeleteContactsByContactIdsMutationHookResult = ReturnType<typeof useDeleteContactsByContactIdsMutation>;
export type DeleteContactsByContactIdsMutationResult = Apollo.MutationResult<DeleteContactsByContactIdsMutation>;
export type DeleteContactsByContactIdsMutationOptions = Apollo.BaseMutationOptions<DeleteContactsByContactIdsMutation, DeleteContactsByContactIdsMutationVariables>;
